import { useCallback } from "react";
import { getCascadeValues } from "../../api/Validations";
import { useWorkOrderStore } from "../../store/wo-order";

export default function useGetCascadeValues() {
  const setCascadeValues = useWorkOrderStore((state) => state.setCascadeValues);
  const getCascadedValues = useCallback(async () => {
    const response = await getCascadeValues();
    setCascadeValues(response.data);
  }, [setCascadeValues]);
  return { getCascadedValues };
}
